import * as React from 'react';
import { compose, withProps, withHandlers } from 'recompose';
import { reduxForm, FormSection, change } from 'redux-form';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Divider from 'material-ui/Divider';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import * as T from '@modules/events/_eventsTypes';

import { Person } from '@components/person';
import { Vehicle } from '@components/vehicle';
import { RemoteAutoCompleteField, RemoteAutoComplete } from '@components/form';
import Address, { AddressField } from '@components/form/Address/Address';
import HelpTooltip from '@components/HelpTooltip/HelpTooltip';

const removeIds = owner => ({
  ...owner,
  id: undefined,
  address: owner.address ? { ...owner.address, id: undefined } : undefined,
  birthAddress: owner.birthAddress ? { ...owner.birthAddress, id: undefined } : undefined
});

const mapStateToProps = state => ({
  participants: get(state, 'form.module-events.values.participants', []),
  owner: get(state, 'form.module-events-vehicles.values.owner', {})
});

const mapDispatchToProps = dispatch => ({
  setPerpetrator: participants => dispatch(change('module-events', 'participants', participants))
});

const enhance = compose<T.EmployeesFormProps, T.Outter & T.EmployeesFormProps>(
  reduxForm({
    form: 'module-events-vehicles'
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withProps(({ owner: { firstName, lastName }, participants }) => {
    const buttonDisabled =
      !firstName ||
      !lastName ||
      !!participants.find(({ person: { firstName: fn, lastName: ln } }) => fn === firstName && ln === lastName);

    return { buttonDisabled };
  }),
  withHandlers({
    createPerpetrator: ({ owner, setPerpetrator, participants }) => () => {
      setPerpetrator([...participants, { person: removeIds(owner), type: 'PERPETRATOR' }]);
    }
  })
);

const View: React.SFC<any> = ({ handleSubmit, closeItem, form, buttonDisabled, createPerpetrator }) => (
  <div>
    <form className="layout" onSubmit={handleSubmit}>
      <Grid fluid={true}>
        <Row>
          <Col md={12}>
            <Row>
              <Col md={12}>
                <h4>Vozidlo</h4>
              </Col>
            </Row>
            <FormSection name="">
              <Vehicle form={form} />
            </FormSection>
            <Row>
              <Col md={6} xl={6} className="with-right-divider">
                <Row>
                  <Col md={12}>
                    <h4>Jméno provozovatele</h4>
                  </Col>
                </Row>
                <FormSection name="owner">
                  <Person
                    withMaidenName={true}
                    withPhone={true}
                    withNote={true}
                    form={form}
                    formName={'owner.'}
                    showCompanyInputs={true}
                  />
                </FormSection>
              </Col>
              <Col md={6} xl={6}>
                <Row>
                  <Col md={12}>
                    <h4>Narození provozovatele</h4>
                  </Col>
                </Row>
                <AddressField component={Address} name={'owner.birthAddress'} />

                <Row>
                  <Col md={12}>
                    <RemoteAutoCompleteField
                      component={RemoteAutoComplete}
                      label="Občanství"
                      name="owner.citizenship"
                      url="/metropolis/api/common/countries"
                      filterActive={true}
                      labelFunction={o => get(o, 'name')}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <h4>Bydliště provozovatele</h4>
                  </Col>
                </Row>
                <AddressField component={Address} name={'owner.address'} />
              </Col>
            </Row>
          </Col>
        </Row>

        <Row>
          <Col className="grid-system-margin" />
        </Row>
      </Grid>

      <Divider />

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
        <Button
          label="Přidat pachatele"
          style={{ margin: '16px 0 16px 16px' }}
          onClick={createPerpetrator}
          disabled={buttonDisabled}
        />
        {buttonDisabled && (
          <HelpTooltip help="Pro přidáni pachatele je potřeba vyplnit alespoň jméno a příjmení držitele, není možné přidat stejného pachatele vícekrát" />
        )}
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
      </div>
    </form>
  </div>
);

export const EventsFormParticipantsVehiclesForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/events/EventsFormParticipantsVehiclesForm.tsx